import { render } from "./PageSoruReferans.vue?vue&type=template&id=2cd9a906"
import script from "./PageSoruReferans.vue?vue&type=script&lang=js"
export * from "./PageSoruReferans.vue?vue&type=script&lang=js"
script.render = render

export default script